import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
import {
  APP_SETTING_LOAD_ALL_DEV_APIS_BEGIN,
  APP_SETTING_LOAD_ALL_DEV_APIS_SUCCESS,
  APP_SETTING_LOAD_ALL_DEV_APIS_FAILURE,
  APP_SETTING_LOAD_ALL_DEV_APIS_DISMISS_ERROR,
} from './constants';
import axios from 'axios';
export function loadAllDevApis(args = {}) {
  return (dispatch) => {
    dispatch({
      type: APP_SETTING_LOAD_ALL_DEV_APIS_BEGIN,
    });
    const { projectId, version } = args;
    const header = builderSurfaceJsonContentHeader(projectId);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.get(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/developer-apis/${projectId}/devapis`,
        header,
      );
      doRequest.then(
        (res) => {
          dispatch({
            type: APP_SETTING_LOAD_ALL_DEV_APIS_SUCCESS,
            data: res.data,
          });
          resolve(res);
        },
        (err) => {
          dispatch({
            type: APP_SETTING_LOAD_ALL_DEV_APIS_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissLoadAllDevApisError() {
  return {
    type: APP_SETTING_LOAD_ALL_DEV_APIS_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case APP_SETTING_LOAD_ALL_DEV_APIS_BEGIN:
      return {
        ...state,
        loadAllDevApisPending: true,
        loadAllDevApisError: null,
      };

    case APP_SETTING_LOAD_ALL_DEV_APIS_SUCCESS:
      return {
        ...state,
        loadAllDevApisPending: false,
        loadAllDevApisError: null,
        projectDevApis: action.data,
      };

    case APP_SETTING_LOAD_ALL_DEV_APIS_FAILURE:
      return {
        ...state,
        loadAllDevApisPending: false,
        loadAllDevApisError: action.data.error,
      };

    case APP_SETTING_LOAD_ALL_DEV_APIS_DISMISS_ERROR:
      return {
        ...state,
        loadAllDevApisError: null,
      };

    default:
      return state;
  }
}
